// Serviço de API para Carteira Digital
import authService from "./authService";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const carteiraService = {
  // Obter carteira do usuário
  async getCarteira(usuarioId, tipoUsuario) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/${usuarioId}/${tipoUsuario}`);
      if (!response.ok) throw new Error('Erro ao buscar carteira');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar carteira:', error);
      throw error;
    }
  },

  // Obter histórico de transações
  async getHistorico(usuarioId, tipoUsuario, limit = 50) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/${usuarioId}/${tipoUsuario}/historico?limit=${limit}`);
      if (!response.ok) throw new Error('Erro ao buscar histórico');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      throw error;
    }
  },

  // Realizar depósito
  async depositar(usuarioId, tipoUsuario, valor, metodo = 'pix') {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/deposito`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario_id: usuarioId,
          tipo_usuario: tipoUsuario,
          valor: valor,
          metodo: metodo
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao realizar depósito');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao realizar depósito:', error);
      throw error;
    }
  },

  // Solicitar saque
  async sacar(usuarioId, tipoUsuario, valor) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/saque`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario_id: usuarioId,
          tipo_usuario: tipoUsuario,
          valor: valor
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao solicitar saque');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao solicitar saque:', error);
      throw error;
    }
  },

  // Atualizar dados bancários
  async atualizarDadosBancarios(usuarioId, tipoUsuario, dadosBancarios) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/dados-bancarios`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usuario_id: usuarioId,
          tipo_usuario: tipoUsuario,
          dados_bancarios: {
            banco: dadosBancarios.banco,
            agencia: dadosBancarios.agencia,
            conta: dadosBancarios.conta,
            tipo_conta: dadosBancarios.tipoConta,
            chave_pix: dadosBancarios.chavePix,
            tipo_chave_pix: dadosBancarios.tipoChavePix
          }
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao atualizar dados bancários');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao atualizar dados bancários:', error);
      throw error;
    }
  },

  // Debitar para publicação
  async debitarPublicacao(usuarioId, tipoUsuario, valor, descricao) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/carteira/debitar-publicacao?usuario_id=${usuarioId}&tipo_usuario=${tipoUsuario}&valor=${valor}&descricao=${encodeURIComponent(descricao)}`, {
        method: 'POST'
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao debitar publicação');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao debitar publicação:', error);
      throw error;
    }
  }
};

// Serviço de API para Fornecedores
export const fornecedorService = {
  // Buscar fornecedores por estado
  async buscarFornecedores(estado = null, categoria = null, nome = null) {
    try {
      const params = new URLSearchParams();
      if (estado) params.append('estado', estado);
      if (categoria) params.append('categoria', categoria);
      if (nome) params.append('nome', nome);
      
      const response = await fetch(`${BACKEND_URL}/api/fornecedores/buscar?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar fornecedores');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar fornecedores:', error);
      throw error;
    }
  }
};

// Serviço de API para WhatsApp
export const whatsappService = {
  // Enviar mensagem WhatsApp
  async enviarMensagem(telefone, mensagem) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/whatsapp/enviar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ telefone, mensagem })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao enviar mensagem');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao enviar mensagem WhatsApp:', error);
      throw error;
    }
  },

  // Verificar status da integração
  async verificarStatus() {
    try {
      const response = await fetch(`${BACKEND_URL}/api/whatsapp/status`);
      if (!response.ok) throw new Error('Erro ao verificar status');
      return await response.json();
    } catch (error) {
      console.error('Erro ao verificar status WhatsApp:', error);
      throw error;
    }
  }
};

// Serviço de API para WMS (Warehouse Management System)
export const wmsService = {
  // Listar produtos do fornecedor
  async getProducts(supplierId, search = null) {
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      const response = await fetch(`${BACKEND_URL}/api/wms/products/${supplierId}?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar produtos');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar produtos WMS:', error);
      throw error;
    }
  },

  // Criar produto
  async createProduct(supplierId, product) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/products/${supplierId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(product)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao criar produto');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao criar produto WMS:', error);
      throw error;
    }
  },

  // Listar pedidos
  async getOrders(supplierId, status = null) {
    try {
      const params = new URLSearchParams();
      if (status) params.append('status', status);
      const response = await fetch(`${BACKEND_URL}/api/wms/orders/${supplierId}?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar pedidos');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar pedidos WMS:', error);
      throw error;
    }
  },

  // Criar pedido
  async createOrder(supplierId, order) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/orders/${supplierId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(order)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao criar pedido');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao criar pedido WMS:', error);
      throw error;
    }
  },

  // Iniciar sessão de picking
  async startPicking(orderId, operatorName = '') {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/picking/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: orderId, operator_name: operatorName })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao iniciar separação');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao iniciar picking:', error);
      throw error;
    }
  },

  // Escanear código de barras
  async scanBarcode(sessionId, barcode) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/picking/scan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId, barcode: barcode })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao processar bipagem');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao escanear código:', error);
      throw error;
    }
  },

  // Finalizar separação
  async finishPicking(sessionId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/picking/finish`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ session_id: sessionId })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao finalizar separação');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao finalizar picking:', error);
      throw error;
    }
  },

  // Marcar pedido como enviado
  async shipOrder(orderId, trackingCode = null) {
    try {
      const params = new URLSearchParams();
      if (trackingCode) params.append('tracking_code', trackingCode);
      const response = await fetch(`${BACKEND_URL}/api/wms/orders/${orderId}/ship?${params.toString()}`, {
        method: 'POST'
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao marcar como enviado');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao enviar pedido:', error);
      throw error;
    }
  },

  // Obter estatísticas
  async getStats(supplierId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/stats/${supplierId}`);
      if (!response.ok) throw new Error('Erro ao buscar estatísticas');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar estatísticas WMS:', error);
      throw error;
    }
  },

  // Obter logs de bipagem
  async getLogs(supplierId, orderId = null, limit = 50) {
    try {
      const params = new URLSearchParams();
      if (orderId) params.append('order_id', orderId);
      params.append('limit', limit);
      const response = await fetch(`${BACKEND_URL}/api/wms/logs/${supplierId}?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar logs');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar logs WMS:', error);
      throw error;
    }
  },

  // Obter movimentações de estoque
  async getInventoryMovements(supplierId, productId = null, limit = 50) {
    try {
      const params = new URLSearchParams();
      if (productId) params.append('product_id', productId);
      params.append('limit', limit);
      const response = await fetch(`${BACKEND_URL}/api/wms/inventory/${supplierId}?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar movimentações');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar movimentações:', error);
      throw error;
    }
  },

  // Ajustar estoque
  async adjustStock(productId, quantity, reason, operatorName = '') {
    try {
      const response = await fetch(`${BACKEND_URL}/api/wms/inventory/adjust`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          product_id: productId, 
          quantity: quantity, 
          reason: reason,
          operator_name: operatorName 
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao ajustar estoque');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao ajustar estoque:', error);
      throw error;
    }
  }
};

// Serviço de API para Perfis de Usuários
export const perfilService = {
  // Obter perfil do afiliado
  async getPerfilAfiliado(usuarioId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/afiliado/${usuarioId}`);
      if (!response.ok) throw new Error('Erro ao buscar perfil');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar perfil afiliado:', error);
      throw error;
    }
  },

  // Salvar perfil do afiliado
  async salvarPerfilAfiliado(usuarioId, dados) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/afiliado/${usuarioId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dados)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao salvar perfil');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao salvar perfil afiliado:', error);
      throw error;
    }
  },

  // Obter perfil do fornecedor
  async getPerfilFornecedor(usuarioId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/fornecedor/${usuarioId}`);
      if (!response.ok) throw new Error('Erro ao buscar perfil');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar perfil fornecedor:', error);
      throw error;
    }
  },

  // Salvar perfil do fornecedor
  async salvarPerfilFornecedor(usuarioId, dados) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/fornecedor/${usuarioId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dados)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao salvar perfil');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao salvar perfil fornecedor:', error);
      throw error;
    }
  },

  // Obter perfil do admin
  async getPerfilAdmin(usuarioId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/admin/${usuarioId}`);
      if (!response.ok) throw new Error('Erro ao buscar perfil');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar perfil admin:', error);
      throw error;
    }
  },

  // Salvar perfil do admin
  async salvarPerfilAdmin(usuarioId, dados) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/perfil/admin/${usuarioId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dados)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao salvar perfil');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao salvar perfil admin:', error);
      throw error;
    }
  }
};

// Serviço de API para Importação de Catálogo
export const catalogoService = {
  // Upload de arquivo CSV
  async uploadCatalogo(fornecedorId, file, usarIA = true) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('usar_ia', usarIA);

      const response = await fetch(`${BACKEND_URL}/api/catalogo/upload/${fornecedorId}`, {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao importar catálogo');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao importar catálogo:', error);
      throw error;
    }
  },

  // Listar produtos importados
  async getProdutos(fornecedorId, importacaoId = null, status = null, limit = 50, skip = 0) {
    try {
      const params = new URLSearchParams();
      if (importacaoId) params.append('importacao_id', importacaoId);
      if (status) params.append('status', status);
      params.append('limit', limit);
      params.append('skip', skip);

      const response = await fetch(`${BACKEND_URL}/api/catalogo/produtos/${fornecedorId}?${params.toString()}`);
      if (!response.ok) throw new Error('Erro ao buscar produtos');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar produtos:', error);
      throw error;
    }
  },

  // Listar importações
  async getImportacoes(fornecedorId, limit = 20) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/catalogo/importacoes/${fornecedorId}?limit=${limit}`);
      if (!response.ok) throw new Error('Erro ao buscar importações');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar importações:', error);
      throw error;
    }
  },

  // Atualizar produto
  async atualizarProduto(produtoId, dados) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/catalogo/produtos/${produtoId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dados)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao atualizar produto');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao atualizar produto:', error);
      throw error;
    }
  },

  // Reprocessar produto com IA
  async reprocessarProduto(produtoId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/catalogo/produtos/${produtoId}/reprocessar`, {
        method: 'POST'
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao reprocessar produto');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao reprocessar produto:', error);
      throw error;
    }
  },

  // Deletar produto
  async deletarProduto(produtoId) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/catalogo/produtos/${produtoId}`, {
        method: 'DELETE'
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao deletar produto');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao deletar produto:', error);
      throw error;
    }
  },

  // Enriquecer produto individual com IA
  async enriquecerProduto(produto) {
    try {
      const response = await fetch(`${BACKEND_URL}/api/catalogo/enriquecer`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(produto)
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao enriquecer produto');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao enriquecer produto:', error);
      throw error;
    }
  }
};

// Serviço de API para Pagamentos PIX
export const pixService = {
  // Criar pagamento PIX
  async criarPagamento(usuarioId, tipoUsuario, valor, descricao, email) {
    try {
      const response = await authService.fetchAuth(`${BACKEND_URL}/api/pix/criar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          valor: valor,
          descricao: descricao,
          email_pagador: email,
          usuario_id: usuarioId,
          tipo_usuario: tipoUsuario
        })
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao criar pagamento PIX');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao criar pagamento PIX:', error);
      throw error;
    }
  },

  // Verificar status do pagamento
  async verificarStatus(pagamentoId) {
    try {
      const response = await authService.fetchAuth(`${BACKEND_URL}/api/pix/status/${pagamentoId}`);
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao verificar status');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao verificar status PIX:', error);
      throw error;
    }
  },

  // Simular aprovação (sandbox - restrito a admin no backend)
  async simularAprovacao(pagamentoId) {
    try {
      const response = await authService.fetchAuth(`${BACKEND_URL}/api/pix/simular-aprovacao/${pagamentoId}`, {
        method: 'POST'
      });
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Erro ao simular aprovação');
      }
      return await response.json();
    } catch (error) {
      console.error('Erro ao simular aprovação PIX:', error);
      throw error;
    }
  },

  // Obter histórico de pagamentos
  async getHistorico(usuarioId, tipoUsuario, limit = 50) {
    try {
      const response = await authService.fetchAuth(`${BACKEND_URL}/api/pix/historico/${usuarioId}/${tipoUsuario}?limit=${limit}`);
      if (!response.ok) throw new Error('Erro ao buscar histórico PIX');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar histórico PIX:', error);
      throw error;
    }
  },

  // Obter configurações
  async getConfig() {
    try {
      const response = await fetch(`${BACKEND_URL}/api/pix/config`);
      if (!response.ok) throw new Error('Erro ao buscar configurações PIX');
      return await response.json();
    } catch (error) {
      console.error('Erro ao buscar configurações PIX:', error);
      throw error;
    }
  }
};

export default { carteiraService, fornecedorService, whatsappService, wmsService, perfilService, catalogoService, pixService };
